import { render, staticRenderFns } from "./EResultadoSemestral.vue?vue&type=template&id=7e5e2c6c"
import script from "./EResultadoSemestral.vue?vue&type=script&lang=js"
export * from "./EResultadoSemestral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports